import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './domain/auth/guards/auth.guard';
import { LoggedInGuard } from './domain/auth/guards/logged-in.guard';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: async () =>
      (await import('./domain/auth/auth.domain.module')).AuthDomainModule,
    canActivate: [LoggedInGuard],
    canLoad: [LoggedInGuard],
  },
  {
    path: '',
    loadChildren: async () =>
      (await import('./domain/home/home.domain.module')).HomeDomainModule,
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
